import * as rsuite from 'rsuite';
import { HiOutlineCheck } from "react-icons/hi";

// The outer add/edit modal chrome (header title + Save/Cancel footer)
// shared by every CRUD list page. The actual field inputs are passed in
// as children — they differ too much per entity (image upload, date
// pickers, dropdowns, checkboxes...) to genericize without becoming a
// fragile form-builder, so they stay owned by each page.
const CrudFormModal = ({ open, title, onClose, onSave, children }) => (
    <rsuite.Modal open={open} onClose={onClose}>
        <rsuite.Modal.Header>
            <p className="sm:text-2xl">{title}</p>
        </rsuite.Modal.Header>
        <rsuite.Modal.Body className="px-2">
            {children}
        </rsuite.Modal.Body>
        <rsuite.Modal.Footer>
            <rsuite.Button onClick={onSave} appearance="primary" color="green" startIcon={<HiOutlineCheck className="me-2" />}>
                ذخیره
            </rsuite.Button>
            <rsuite.Button onClick={onClose} appearance="subtle">
                انصراف
            </rsuite.Button>
        </rsuite.Modal.Footer>
    </rsuite.Modal>
);

export default CrudFormModal;
